module.exports = __webpack_public_path__ + "img/pending_zone.ade8ad97.svg";